// extracted by mini-css-extract-plugin
export default {"home":"Home_home__IjCd-","home__wrap":"Home_home__wrap__qRmG5","home__inner":"Home_home__inner__qloMj","table":"Home_table__E6LuY"};